/**
 * Enumeration of vehicle usage type in relation with the type of driver that can be assigned to the vehicle.
 * @readonly
 * @enum {string}
 */
export const VehicleUsageType = Object.freeze({
    POOL_CAR: 'POOL_CAR',
    FIXED_DRIVER_CAR: 'FIXED_DRIVER_CAR',
    UNKNOWN: 'UNKNOWN'
})
